/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { useAppDispatch, useAppSelector } from 'store';
import { SampleList } from 'components/Sample/SampleList';
import { PageTitles } from 'constants/pageTitles';
import { IArticlesItem } from 'store/slices/articles/interfaces';
import {
  loadArticlesList,
  removeArticlesItem,
} from 'store/slices/articles/actions';

interface IProps {
  sortFieldName?: keyof Pick<
    IArticlesItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  limit?: number;
  addON?: boolean;
  deleteON?: boolean;
  isSortPriority?: boolean | null;
}

export const List: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  limit,
  addON,
  deleteON,
  isSortPriority = true,
}) => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(state => state.articles);

  const tableData = data.list.map(item => ({
    title: item.name,
    id: item.id,
    sortPriority: item[sortFieldName],
    image: item.image,
  }));

  const handleRemove = async (id: number): Promise<any> => {
    return dispatch(
      removeArticlesItem({
        id,
        [sortFieldName]: null,
      })
    ).unwrap();
  };

  const handleLoadData = () => {
    dispatch(
      loadArticlesList({
        limit,
        sort: sortFieldName,
        isSortPriority,
      })
    );
  };

  return (
    <SampleList
      data={tableData}
      handleLoadData={handleLoadData}
      handleDelete={handleRemove}
      isLoading={data.isLoading}
      title={PageTitles.articles}
      limit={4}
      addON={addON}
      deleteON={deleteON}
    />
  );
};
